/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';
import { IUserGaDataLayerResponseSchema } from '../../entities/views/UserGaDataLayerResponseSchema';

export type TGetUserGaDataLayerDataModel = IModel<IGetUserGaDataLayerDataRequest, TGetUserGaDataLayerDataResponse>;

export interface IGetUserGaDataLayerDataRequest {}

export type TGetUserGaDataLayerDataResponse = IGetUserGaDataLayerDataResponse200 | IGetUserGaDataLayerDataResponse400;

export interface IGetUserGaDataLayerDataResponse200 extends IModelResponse<IGetUserGaDataLayerDataResponse> {
  statusCode: 200;
}

export interface IGetUserGaDataLayerDataResponse400 extends IModelResponse<IGetUserGaDataLayerDataResponseError> {
  statusCode: 400;
}

export interface IGetUserGaDataLayerDataResponse {
  data: IUserGaDataLayerResponseSchema;
  status: EStatus;
}

export interface IGetUserGaDataLayerDataResponseError {
  errors: any[];
  message: string;
}

export type TResponses = IGetUserGaDataLayerDataResponse | IGetUserGaDataLayerDataResponseError;

export enum EStatus {
  /** undefined **/
  Ok = 'ok',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetUserGaDataLayerDataResponse): TResponse200;
  400(response: IGetUserGaDataLayerDataResponseError): TResponse400;
}
